import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import rice from '../../../../images/raw_material/rice.png';
import dhalimage from '../../../../images/raw_material/dhal.png';
import tomatoimage from '../../../../images/raw_material/tomato.png';
import Consumption from '../../../modal/Purchase_Management/Manage_Stocks/Consumption';
import ConsumptionHistory from '../../../modal/Purchase_Management/Manage_Stocks/Consumption_His';
import ConsumptionReturn from '../../../modal/Purchase_Management/Manage_Stocks/ConsumptionReturn';
import ResolveReason from '../../../modal/Purchase_Management/Manage_Stocks/StockchecklistReason';
import ViewVessel from '../../../modal/Purchase_Management/Manage_Stocks/ViewVessel';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import {  Col, Tab, Nav } from "react-bootstrap";
import Select from 'react-select';
import DatePicker from "react-multi-date-picker";
import dayjs from 'dayjs';
import View from '../../../modal/Purchase_Management/Manage_Stocks/ViewStock';
import isBetween from 'dayjs/plugin/isBetween';
import axios from 'axios';

dayjs.extend(isBetween);

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
          diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff)); 
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
          diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};
const baseURL = process.env.REACT_APP_API_BASE_URL;

const Stock = () => {
    
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id
        };
        axios.get(`${baseURL}/stock/checklist_history`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);


    const [open, setOpen] = useState(false); // Modal visibility state
    const [modalType, setModalType] = useState("");
    const [key, setKey] = useState('manage_history');
    const [hide,setHide]=useState('d-block');


    const handleModalToggle = () => {
        setModalType("View");
        setOpen(true);
    };


    useEffect(() => {
        const tables = document.querySelectorAll('.product_data_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];


    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] =  useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    const [today_fil_value, setTodayFilValue] = useState(new Date());

    useEffect(() => {
        const params = {
            date_filter: date_fil_selt_value,
        };
        if (date_fil_selt_value === 'today') {
            params.start_date = dayjs(today_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(today_fil_value).format('DD-MM-YYYY');
        } else if (date_fil_selt_value === 'this_week') {
            params.start_date = dayjs(week_stdt_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(week_eddt_fil_value).format('DD-MM-YYYY');
        } else if (date_fil_selt_value === 'this_month') {
            const startOfMonth = dayjs(month_fil_value).startOf('month').format('DD-MM-YYYY');
            const endOfMonth = dayjs(month_fil_value).endOf('month').format('DD-MM-YYYY');
            params.start_date = startOfMonth;
            params.end_date = endOfMonth;
        } else if (date_fil_selt_value === 'custom') {
            params.start_date = dayjs(custom_stdt_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(custom_eddt_fil_value).format('DD-MM-YYYY');
        }
        fetchData(params);

    }, [date_fil_selt_value, custom_stdt_fil_value, custom_eddt_fil_value, month_fil_value, week_stdt_fil_value, week_eddt_fil_value]);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Stocks</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Purchase Management</li>
                    </ol>
                </div>
                <Link to='/stocks-checklist' className={`btn btn-primary float-end btn-sm ${hide}`}>
                    <span className='me-2'><i class="fa-solid fa-list-check  fs-8"></i></span>
                    <span className=''>Stock Checklist</span>
                </Link>

                {open && modalType === "View" && (
                    <View show={open} onClose={() => setOpen(false)} />
                )}
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/manage-stocks" >
                                    <i className="fa-regular fa-user me-2" />
                                    <label className="ms-2 fs-6">
                                        Manage Stock
                                    </label>

                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link eventKey="manage_history">
                                    <i className="fa-solid fa-list-check me-2" />
                                    <label className="ms-2 fs-6">
                                        Stock Checklist History
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-stocks-vessels" >
                                    <i className="fa-solid fa-kitchen-set me-2" /> 
                                    <label className="ms-2 fs-6">
                                        Manage Vessel Stock
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/manage-stocks-consumption" >
                                    <i className="fa-solid fa-cookie-bite me-2" /> 
                                    <label className="ms-2 fs-6">
                                        Stock Consumption
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                         
                        <Tab.Content className="pt-4">
                            
                            <Tab.Pane eventKey="manage_history">
                                <div className='row mb-4'>
                                    <div className="col-lg-3 mb-2">
                                        <label className="text-black font-w500 fs-7">Date</label>
                                        <Select
                                            value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                            onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                            options={date_fil_options}
                
                                        />
                                    </div>
                                    {date_fil_selt_value === "all" && <></>}
                                    {date_fil_selt_value === "today" && (
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">Today</label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'>
                                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                                </div>
                                                <DatePicker
                                                    // value={"05/18/2020 02:20:36 PM"}
                                                    value={today_fil_value}
                                                    onChange={setTodayFilValue}
                                                    format="DD-MM-YYYY"
                                                    // format="DD/MM/YYYY hh:mm:ss A"
                                                    readOnly={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {date_fil_selt_value === "this_week"  && (
                                        <>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Start Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={week_stdt_fil_value}
                                                        onChange={setWeekSTDTFilValue}
                                                        format="DD-MM-YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">End Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={week_eddt_fil_value}
                                                        onChange={setWeekEDDTFilValue}
                                                        format="DD-MM-YYYY"
                                                        calendarPosition="top-end"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {date_fil_selt_value === "this_month" && (
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">This Month</label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                <DatePicker
                                                    value={month_fil_value}
                                                    onChange={setMonthFilValue}
                                                    format="MMM-YYYY"
                                                    calendarPosition="top"
                                                    mode="single"
                                                    onlyMonthPicker={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {date_fil_selt_value === "custom" && (
                                        <>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Start Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={custom_stdt_fil_value}
                                                        onChange={setCustomSTDTFilValue}
                                                        format="DD-MM-YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">End Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={custom_eddt_fil_value}
                                                        onChange={setCustomEDDTFilValue}
                                                        format="DD-MM-YYYY"
                                                        calendarPosition="top-end"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className="table-container">

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                className="form-select d-inline w-auto"
                                                style={{  fontSize: '0.85rem', height: '30px' }}
                                                value={perPage}
                                                onChange={(e) => {
                                                    setPerPage(Number(e.target.value));
                                                    setPage(1); // Reset to first page
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <input
                                                type="text"
                                                style={{  fontSize: '0.85rem', height: '40px' }}
                                                placeholder="Search..."
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(1); // Reset page on new search
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <table className=" table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-100px text-start'>Date</th>
                                                <th className='min-w-100px'>Raw Material</th>
                                                <th className='min-w-100px'>Total Qty/Units</th>
                                                <th className='min-w-100px'>Consume Qty/Units</th>
                                                <th className='min-w-100px'>Remained Qty/Units</th>
                                                <th className='min-w-100px'>Variations</th>
                                                <th className='min-w-80px'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {datas.length === 0 && hasFetched ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center text-muted py-2">
                                                        No data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {datas.map((data, index) => (
                                                        <tr key={data.sno}>
                                                            <td>
                                                                <Badge bg="none" className='text-info border border-info fs-7 py-0 px-1'>{data.formated_consumption_date}</Badge>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>
                                                                    {data.raw_material_name}
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>
                                                                    {data.total_quantity} {data.total_units ? data.total_units : ''}
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>
                                                                    {data.consume_quantity} {data.consumed_units ? data.consumed_units : ''}
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <Badge bg="danger" className='text-white fs-8 py-0 px-1'>
                                                                    {data.remaining_quantity} {data.remain_unit ? data.remain_unit : ''}
                                                                </Badge>
                                                            </td>
                                                            <td>
                                                                {data.variation_quantity ? (
                                                                    <div className='d-flex flex-row align-items-center justify-content-start gap-2'>
                                                                        <Badge bg="warning" className='text-white fs-8 py-0 px-1'>
                                                                            {data.variation_quantity} {data.remain_unit ? data.remain_unit : ''}
                                                                        </Badge>
                                                                        {data.variation_reason && (
                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.variation_reason}</span></Tooltip>} >
                                                                                <span>
                                                                                    <i class="fa-solid fa-circle-question text-primary"></i>
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    ' - '
                                                                )}
                                                            </td>
                                                            <td class="text-center">
                                                                <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                                    <Button variant="tp-btn-light text-primary px-2 py-1 me-1" onClick={handleModalToggle} style={{ color: 'black' }}>
                                                                        <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            )}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            {datas.length > 0 ? (
                                                <span className="text-muted">
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                </span>
                                            ):(
                                                <span className="text-muted">
                                                    Showing 0 to 0 of 0 entries
                                                </span>
                                            )}
                                        </div>

                                        {/* Bottom right: Pagination */}
                                        <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                {/* Previous Button */}
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                    Previous
                                                </button>
                                                </li>

                                                {/* First Page */}
                                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                    1
                                                </button>
                                                </li>

                                                {/* Left Ellipsis */}
                                                {page > 4 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Pages Around Current */}
                                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                .map(p => (
                                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                        {p}
                                                    </button>
                                                    </li>
                                                ))}

                                                {/* Right Ellipsis */}
                                                {page < totalPages - 3 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Last Page */}
                                                {totalPages > 1 && (
                                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                    {totalPages}
                                                    </button>
                                                </li>
                                                )}

                                                {/* Next Button */}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                    Next
                                                </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>
                            </Tab.Pane>
                            
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    )


}
export default Stock;